import ContactGroup from './ContactGroup';

export default ContactGroup;
